import React from 'react';
import './style.scss';

/**
 * NoRegisterMessage component - alternative text when there are no comments in CommentModal.
 *
 * @param {Object} props - Props for the NoRegisterMessage component.
 * @param {React.ReactNode} props.children - The children elements.
 * @returns {JSX.Element} The NoRegisterMessage component.
 * @example
 *  <NoRegisterMessage>
 *      ...
 *  </NoRegisterMessage>
 */
function NoRegisterMessage({ children }) {
    return (
        <div className="no-register-message">
            {children}
        </div>
    );
}

export default NoRegisterMessage;

